import { CreditReferenceList } from "./credit-reference-list";
import { CreditRequestBankReferenceInformation } from "./credit-request-bank-reference-information";
import { CreditRequestContactInformation } from "./credit-request-contact-information";

export class CreditRequestData {
    Actividad_Economica: string;
    Aldea_Barrio_Caserio_Colonia: string;
    Aldea_Barrio_Caserio_Colonia_Empresa: string;
    Calle1: string;
    Calle1_Empresa: string;
    Calle2: string;
    Calle2_Empresa: string;
    Calle3: string;
    Calle3_Empresa: string;
    Calle4: string;
    Calle4_Empresa: string;
    Calle5: string;
    Calle5_Empresa: string;
    Cargo: string;
    Causa: string;
    Celular: string;
    Celular_Conyuge: string;
    Ciudad_Municipio: string;
    Ciudad_Municipio_Empresa: string;
    Codigo_Centro: string;
    Codigo_Cliente_BP: string;
    Codigo_Sociedad: string;
    Codigo_Solicitud: string;
    Codigo_Solicitud_Principal: string;
    Correo_Electronico: string;
    Departamento: string;
    Departamento_Empresa: string;
    Departamento_Labora: string;
    Desde_cuando_las_recibe: string;
    Desde_hace_cuanto_se_dedica: string;
    Division: string;
    Edad: string;
    Empresa: string;
    Especifique: string;
    Estado_Civil: string;
    Extension_Telefono_Empresa: string;
    Fecha: string;
    Fecha_Ingreso_Empresa: string;
    Fecha_Nacimiento: string;
    Fuente_Ingreso: string;
    Giro_Actividad_economica: string;
    Hora: string;
    ID_Causa: string;
    ID_TipoIdentificacion: string;
    ID_Tipo_Tramite: string;
    Identificacion: string;
    Ingreso: string;
    ListaReferencias: Array<CreditReferenceList>;
    Monto_Aprobado: string;
    Monto_Sugerido_Credito: string;
    Nacionalidad: string;
    Nombre: string;
    Nombre_Lugar_Trabajo: string;
    Nombre_Legal: string;
    Nombre_Negocio: string;
    Nombre_Remitente: string;
    Numero_Dependientes: string;
    Numero_Empleados: string;
    Observaciones_Ventas: string;
    Ocupacion: string;
    Origen: string;
    Pais: string;
    Pais_Trabajo: string;
    Parentesco: string;
    Periodicidad: string;
    Primer_Apellido: string;
    Primer_Apellido_Conyuge: string;
    Primer_Nombre: string;
    Primer_Nombre_Conyuge: string;
    Procedencia: string;
    ReglaLimite: string;
    Relacion_Empresa: string;
    Salario_Mensual: string;
    Segmento: string;
    Segundo_Apellido: string;
    Segundo_Apellido_Conyuge: string;
    Segundo_Nombre: string;
    Segundo_Nombre_Conyuge: string;
    Sexo: string;
    Telefono: string;
    Telefono_Empresa: string;
    Telefono_Trabajo_Conyuge: string;
    Tipo_Cliente: string;
    Tipo_Contrato: string;
    Tipo_Empresa: string;
    Tipo_Identificacion: string;
    Tipo_Ingreso: string;
    Tipo_Solicitante: string;
    Tipo_Vivienda: string;
    Titulo_Academico: string;
    Tramite: string;
    Vehiculo: string;
    Vendedor: string;
    Vive_Desde: string;
    clienteAsociado: string;
    codigoSolicitudAval: string;
    Nombre_Comercial: string;
    Fecha_inicio_operaciones: string;
    Tamano_empresa: string;
    ListaContactosEncargadosPago: CreditRequestContactInformation[];
    ListaReferenciasBancarias: CreditRequestBankReferenceInformation[];
    constructor() {
        this.Actividad_Economica = "";
        this.Aldea_Barrio_Caserio_Colonia = "";
        this.Aldea_Barrio_Caserio_Colonia_Empresa = "";
        this.Calle1 = "";
        this.Calle1_Empresa = "";
        this.Calle2 = "";
        this.Calle2_Empresa = "";
        this.Calle3 = "";
        this.Calle3_Empresa = "";
        this.Calle4 = "";
        this.Calle4_Empresa = "";
        this.Calle5 = "";
        this.Calle5_Empresa = "";
        this.Cargo = "";
        this.Causa = "";
        this.Celular = "";
        this.Celular_Conyuge = "";
        this.Ciudad_Municipio = "";
        this.Ciudad_Municipio_Empresa = "";
        this.Codigo_Centro = "";
        this.Codigo_Cliente_BP = "";
        this.Codigo_Sociedad = "";
        this.Codigo_Solicitud = "";
        this.Codigo_Solicitud_Principal = "";
        this.Correo_Electronico = "";
        this.Departamento = "";
        this.Departamento_Empresa = "";
        this.Departamento_Labora = "";
        this.Desde_cuando_las_recibe = "";
        this.Desde_hace_cuanto_se_dedica = "";
        this.Division = "";
        this.Edad = "";
        this.Empresa = "";
        this.Especifique = "";
        this.Estado_Civil = "";
        this.Extension_Telefono_Empresa = "";
        this.Fecha = "";
        this.Fecha_Ingreso_Empresa = "";
        this.Fecha_Nacimiento = "";
        this.Fuente_Ingreso = "";
        this.Giro_Actividad_economica = "";
        this.Hora = "";
        this.ID_Causa = "";
        this.ID_TipoIdentificacion = "";
        this.ID_Tipo_Tramite = "";
        this.Identificacion = "";
        this.Ingreso = "";
        this.ListaReferencias = [];
        this.Monto_Sugerido_Credito = "";
        this.Nacionalidad = "";
        this.Nombre = "";
        this.Nombre_Lugar_Trabajo = "";
        this.Nombre_Negocio = "";
        this.Nombre_Remitente = "";
        this.Numero_Dependientes = "";
        this.Numero_Empleados = "";
        this.Observaciones_Ventas = "";
        this.Ocupacion = "";
        this.Origen = "";
        this.Pais = "";
        this.Pais_Trabajo = "";
        this.Parentesco = "";
        this.Periodicidad = "";
        this.Primer_Apellido = "";
        this.Primer_Apellido_Conyuge = "";
        this.Primer_Nombre = "";
        this.Primer_Nombre_Conyuge = "";
        this.Procedencia = "";
        this.ReglaLimite = "";
        this.Relacion_Empresa = "";
        this.Salario_Mensual = "";
        this.Segmento = "";
        this.Segundo_Apellido = "";
        this.Segundo_Apellido_Conyuge = "";
        this.Segundo_Nombre = "";
        this.Segundo_Nombre_Conyuge = "";
        this.Sexo = "";
        this.Telefono = "";
        this.Telefono_Empresa = "";
        this.Telefono_Trabajo_Conyuge = "";
        this.Tipo_Cliente = "";
        this.Tipo_Contrato = "";
        this.Tipo_Empresa = "";
        this.Tipo_Identificacion = "";
        this.Tipo_Ingreso = "";
        this.Tipo_Solicitante = "";
        this.Tipo_Vivienda = "";
        this.Titulo_Academico = "";
        this.Tramite = "";
        this.Vehiculo = "";
        this.Vendedor = "";
        this.Vive_Desde = "";
        this.clienteAsociado = "";
        this.codigoSolicitudAval = "";
        this.Monto_Aprobado = "";
        this.Nombre_Legal = "";
        this.Nombre_Comercial = "";
        this.Fecha_inicio_operaciones = "";
        this.Tamano_empresa = "";
        this.ListaContactosEncargadosPago = [];
        this.ListaReferenciasBancarias = [];
    }
}